export const getAuthUserId = state => state.auth.userId
export const getAuthFailed = state => state.auth.failed
export const getNoRedirect = state => state.auth.noRedirect
